import { useEffect, useMemo } from 'react'
import { DocStore } from 'stores/DocStore'
import { useRootStore } from 'stores/RootStore'
import { useWebsocketConnection } from 'providers/WebsocketProvider'

/**
 * This hook provides a safe way to instantiate a docStore and destroy it when
 * the component is unmounted. React 17 made useEffect cleanup function
 * asynchronous, so we must make sure that the docStore referenced by the
 * cleanup function is the correct one.
 * This hook should be used by components that provide a DocStoreProvider to
 * their children.
 */
export const useDocStoreSync = (articleId: string) => {
  const rootStore = useRootStore()
  const websocketConnection = useWebsocketConnection()

  const docStore = useMemo(
    () => new DocStore(rootStore, articleId, true, websocketConnection),
    [articleId, rootStore, websocketConnection],
  )

  useEffect(() => {
    docStore.setWebsocketConnection(websocketConnection)
  }, [docStore, websocketConnection])

  useEffect(() => {
    return () => docStore.destroy()
  }, [docStore])

  return docStore
}
